module.exports = __webpack_public_path__ + "static/media/Q.93a15df7.svg";